import topic from '../topic';
export const procAPI = {
  get_procs: topic.procTopic + '/get_procs', //获取列表信息
  add_proc: topic.procTopic + '/add_proc', //增加工序分配
  get_proc_by_id: topic.procTopic + '/get_proc_by_id', //通过id获取数据
  edit_proc: topic.procTopic + '/edit_proc', //编辑数据
  destroy_proc_by_ids: topic.procTopic + '/destroy_proc_by_ids', //删除
  get_user_proc: topic.procTopic + '/get_user_proc' ,//
  get_procs_v1: topic.procTopic + '/get_procs_v1' //获取工序列表
};
